import { Link } from "react-router-dom";

/** Full class literals so Tailwind can detect them. */
const VARIANTS = {
  primary: "bg-sun-500 text-ink hover:bg-sun-400 border border-sun-500 hover:border-sun-400",
  secondary: "bg-brand-500 text-white hover:bg-brand-600 border border-brand-500 hover:border-brand-600",
  outline: "bg-white text-brand-700 border border-brand-300 hover:border-brand-500 hover:bg-brand-50",
};

const SIZES = {
  md: "px-6 py-3 text-base",
  lg: "px-8 py-4 text-lg",
  sm: "px-4 py-2 text-sm",
};

/**
 * Pill button. Renders a router <Link> when `to` is set, an <a> when `href` is set, otherwise a <button>.
 * Brand rule: one primary (orange) action per screen.
 */
export function Button({
  variant = "primary",
  size = "md",
  to,
  href,
  external = false,
  className = "",
  children,
  ...rest
}) {
  const classes = `inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg font-semibold transition-colors duration-200 ${VARIANTS[variant] ?? VARIANTS.primary} ${SIZES[size] ?? SIZES.md} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    const extra = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return (
      <a href={href} className={classes} {...extra} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}
